"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../../button");
var _Toolbox = require("./Toolbox.style");
var _helpers = require("../helpers");
var _ToolboxFunctionsItems = _interopRequireDefault(require("./ToolboxFunctionsItems"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var buttonsId = 'formula-toolbox';
var leftParanthesisLabel = '(';
var rightParanthesisLabel = ')';
var Toolbox = /*#__PURE__*/function (_React$PureComponent) {
  function Toolbox() {
    _classCallCheck(this, Toolbox);
    return _callSuper(this, Toolbox, arguments);
  }
  _inherits(Toolbox, _React$PureComponent);
  return _createClass(Toolbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        actions = _this$props.actions,
        functionsEnabled = _this$props.functionsEnabled,
        focusedPath = _this$props.focusedPath,
        labels = _this$props.labels,
        paranthesesEnabled = _this$props.paranthesesEnabled,
        disabled = _this$props.disabled,
        betweenEnabled = _this$props.betweenEnabled,
        className = _this$props.className,
        noFunctions = _this$props.noFunctions,
        noGroups = _this$props.noGroups,
        noBetween = _this$props.noBetween,
        clearFocus = _this$props.clearFocus,
        keysPath = _this$props.keysPath,
        thresholdIndex = _this$props.thresholdIndex,
        thresholdRowIndex = _this$props.thresholdRowIndex;
      var reachedMaxNestingPath = (0, _helpers.hasReachedMaxNestingDept)(focusedPath);
      return /*#__PURE__*/_react["default"].createElement(_Toolbox.StyledToolbox, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_Toolbox.StyledToolboxWrapper, {
        hasNone: noGroups && noFunctions && noBetween
      }, !noGroups && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-left-parenthesis",
        disabled: !paranthesesEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addLeftBracket(keysPath);
          clearFocus();
        },
        type: "naked"
      }, leftParanthesisLabel), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-right-parenthesis",
        disabled: !paranthesesEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addRightBracket(keysPath);
          clearFocus();
        },
        type: "naked"
      }, rightParanthesisLabel)), !noFunctions && /*#__PURE__*/_react["default"].createElement(_ToolboxFunctionsItems["default"], {
        labels: labels,
        buttonsId: buttonsId,
        functionsEnabled: functionsEnabled,
        reachedMaxNestingPath: reachedMaxNestingPath,
        disabled: disabled,
        keysPath: keysPath,
        actions: actions,
        clearFocus: clearFocus
      }), !noBetween && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        className: "toolbox-formula-button toolbox-formula-between",
        key: "".concat(buttonsId, "-between"),
        disabled: !betweenEnabled || disabled,
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addFunctionBetween(thresholdIndex, thresholdRowIndex);
          clearFocus();
        },
        type: "naked"
      }, labels.FORMULA_BETWEEN_FUNCTION_LABEL)));
    }
  }]);
}(_react["default"].PureComponent);
Toolbox.defaultProps = {
  noBetween: false,
  noGroups: false,
  noFunctions: false,
  disabled: false,
  focusedPath: [],
  functionsEnabled: false,
  betweenEnabled: false,
  className: 'Formula-toolbox',
  thresholdIndex: 0,
  thresholdRowIndex: 0
};
Toolbox.propTypes = {
  disabled: _propTypes["default"].bool,
  clearFocus: _propTypes["default"].func.isRequired,
  noBetween: _propTypes["default"].bool,
  noGroups: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  focusedPath: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  functionsEnabled: _propTypes["default"].bool,
  betweenEnabled: _propTypes["default"].bool,
  actions: _propTypes["default"].shape({
    addLeftBracket: _propTypes["default"].func.isRequired,
    addRightBracket: _propTypes["default"].func.isRequired,
    addFunctionMin: _propTypes["default"].func.isRequired,
    addFunctionMax: _propTypes["default"].func.isRequired,
    addFunctionBetween: _propTypes["default"].func.isRequired,
    addFunctionRound: _propTypes["default"].func.isRequired,
    addFunctionRoundUp: _propTypes["default"].func.isRequired,
    addFunctionRoundDown: _propTypes["default"].func.isRequired
  }).isRequired,
  paranthesesEnabled: _propTypes["default"].bool.isRequired,
  className: _propTypes["default"].string,
  noFunctions: _propTypes["default"].bool,
  thresholdIndex: _propTypes["default"].number,
  thresholdRowIndex: _propTypes["default"].number,
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number]).isRequired
};
var _default = exports["default"] = Toolbox;